import { IAuthState } from "@/interfaces/state";

export default {
  token: (state: IAuthState): string => state.token,
  expiresIn: (state: IAuthState): number => state.expiresIn,
  type: (state: IAuthState): string => state.type,
};
